module.exports = __webpack_public_path__ + "static/meetrix-offer-f80df2d99000db64001f8a84afe7055e.png";